import _ from 'underscore';
import { useCallback, useState, useRef, } from 'react';
import { handleRealUsedFlag } from '@bingads-webui-campaign-react/asset-library-model';

export const useSearchBoxFilter = ({ logger, preference, realUsedFlagSuffix }) => {
  const [searchText, setSearchText] = useState('');
  const searchTextValueRef = useRef('');
  const onSearchTextChanging = useCallback((evt, newValue) => {
    searchTextValueRef.current = newValue || '';
  }, []);

  const onSearchTextBlur = useCallback(() => {
    setSearchText(searchTextValueRef.current);
  }, []);

  const onSearchTextChange = useCallback((newValue) => {
    if (newValue !== searchText) {
      logger.logTrace('start searching text', { searchText: newValue });
      setSearchText(newValue);
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
  }, [logger, searchText, realUsedFlagSuffix, preference]);

  const onSearchTextClear = useCallback(() => {
    if (!_.isEmpty(searchText)) {
      logger.logTrace('start searching text', { searchText: '<empty>' });
      setSearchText('');
    }
  }, [logger, searchText]);

  return {
    searchText,
    onSearchTextChanging,
    onSearchTextBlur,
    onSearchTextChange,
    onSearchTextClear,
  };
};
